<template>
    <div class="sliber">
        <div style='margin-bottom:50px;'>
            <p class="sliber-title">文本系列</p>
            <ul class="sliber-ul">
                <li :class="currentType=='wbdh'?'active-box':''" @click="changeTile('wbdh','/api-reference/response')"><span class="left" :class="currentType=='wbdh'?'active':''">POST</span> <span class="right" :class="currentType=='wbdh'?'active':''">创建文本对话请求</span></li>
                <!-- <li :class="currentType=='wbqr'?'active-box':''" @click="changeTile('wbqr','/api-reference/embedding')"><span class="left" :class="currentType=='wbqr'?'active':''">POST</span> <span class="right" :class="currentType=='wbqr'?'active':''">创建嵌入请求</span></li>
                <li :class="currentType=='wbpx'?'active-box':''" @click="changeTile('wbpx','/api-reference/sort')"><span class="left" :class="currentType=='wbpx'?'active':''">POST</span> <span class="right" :class="currentType=='wbpx'?'active':''">创建重排序请求</span></li> -->

            </ul>
        </div>
         <div>
            <p class="sliber-title">平台系列</p>
            <ul class="sliber-ul">
                <li :class="currentType=='yhmx'?'active-box  ':''" @click="changeTile('yhmx','/api-reference/platform')"><span class="left" :class="currentType=='yhmx'?'active active-bg':'leftget'">GET</span> <span class="right" :class="currentType=='yhmx'?'active':''">获取用户模型列表</span></li>
                <!-- <li :class="currentType=='wbqr'?'active-box':''" @click="changeTile('wbqr','/api-reference/embedding')"><span class="left" :class="currentType=='wbqr'?'active':''">POST</span> <span class="right" :class="currentType=='wbqr'?'active':''">创建嵌入请求</span></li>
                <li :class="currentType=='wbpx'?'active-box':''" @click="changeTile('wbpx','/api-reference/sort')"><span class="left" :class="currentType=='wbpx'?'active':''">POST</span> <span class="right" :class="currentType=='wbpx'?'active':''">创建重排序请求</span></li> -->

            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "Home",
    data() {
        return {
            currentType:'wbdh'
            
        }
    },
    watch: {
    '$route.query.type'(newVal) {
        this.currentType = newVal || 'wbdh'
    }

},
    mounted(){
        this.currentType=window.location.href.split('type=')[1]
    },
    methods:{
        changeTile(name,url){
            this.currentType=name;
            this.$router.push({path:url,query:{type:name}})

        }
    }
}


</script>
<style scoped>
.sliber{

    font-size:.85rem;
    font-weight: bold;
    text-align: left;
    width:250px;
    position: fixed;

}
.sliber-ul{
    cursor: pointer;
}
.sliber-title{
    margin-bottom:10px;
}
.sliber .left{
    color:rgb(29 78 217);
    padding:0 5px ;
    background: rgba(96,165,250,.2);
    /* display: inline-block; */
    border-radius: 6px;
    height:16px;
    line-height: 16px;
    font-size:.6rem;
    float:left;
    margin-top: 10px;
    margin-right: 10px;
}
.sliber .leftget{
        background-color: rgba(74, 222, 128, .2);    color: rgb(22 129 62);
}
.sliber .left.active{
    background-color: rgb(49 101 229);
    color:#fff;
}
.sliber .left.active-bg{
    background-color:rgb(43 185 117);
}

.sliber li{
    width:240px;
    border-radius: 10px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
}
 .sliber .active-box{
    color:#fff;
    /* padding:0 5px ; */
    background: rgb(126 59 239 / 10%);
    display: inline-block;
    line-height: 38px;
  
    font-size:.6rem
} 
.sliber .right{
    font-size:.85rem
}
.sliber .right.active{
    color: rgb(124 58 238);
}
</style>